import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
// import {
//   LinkIcon
// } from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdPercent extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func,
    fieldName: PropTypes.string.isRequired,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col-right'
      onClick={
        this.props.mobile ?
          () => { } :
          this.props.clickShareclass(this.props.shareclass)
      }
    >
      { format.perc(this.props.shareclass[this.props.fieldName]) }
    </td>
  }
}